module.exports = __webpack_public_path__ + "img/hezuo.8847a130.png";